import React from 'react';
import './styles/Hero.css';

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Computer Graphics Algorithms Simulator</h1>
        <p>Visualize step-by-step execution of classic graphics drawing algorithms</p>
        <div className="hero-description">
          <p>Understand how computers draw lines and circles with mathematical precision</p>
        </div>
      </div>
      <div className="hero-accent"></div>
    </section>
  );
}
